import { context } from 'api';
import * as types from '../../mutationTypes';

export default {
    async getAll({ commit }) {
        const responseContext = await context.getContext();

        const data = {
            context: responseContext.data,
        };
        commit(types.BULK_ADD_CLIENT_CONTEXT_ITEMS, data);
    },

    async updateContextItem({ commit }, details) {
        const { key, ...payload } = details;

        const response = await context.updateContextItem(key, payload);
        commit(types.UPDATE_CLIENT_CONTEXT_ITEM, response.data);
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/clientContext/actions.js